(ns com.theplantscape.svg-generation.ensemble
  (:require [com.theplantscape.svg-generation.diagram :as d]
            [com.theplantscape.svg-generation.objects :as o]
            [com.theplantscape.svg-generation.filters :as f]
            [com.theplantscape.svg-generation.patterns :as p]
            [com.theplantscape.svg-generation.compat :as c]
            #?(:clj [com.theplantscape.svg-generation.render :as r])))

(def style-use-map? c/style-use-map?)
(def view-box c/view-box)
(def transform-origin c/transform-origin)
(def tree-filter f/tree-filter)
(def bush-filter f/bush-filter)
(def ground-filter f/ground-filter)
(def leaf-filter f/leaf-filter)
(def hedge-filter f/hedge-filter)
(def goo-filter f/goo-filter)
(def hatch-filter f/hatch-filter)
(def filters f/filters)
(def svg-no-pattern p/svg-no-pattern)
(def svg-pattern-1 p/svg-pattern-1)
(def svg-pattern-2 p/svg-pattern-2)
(def svg-pattern-3 p/svg-pattern-3)
(def svg-pattern-4 p/svg-pattern-4)
(defn rkey [id] (c/rkey id))

(defn draw-layer [svg-plant data] (d/draw-layer svg-plant data))
(defn generate-diagram [defs layers] (d/generate-diagram defs layers))

(defn area-patterns [plants] (o/area-patterns plants))
(defn polyculture [plants] (o/polyculture plants))
(defn boundary [boundaries] (o/boundary boundaries))
(defn canopy-tree [tree] (o/canopy-tree tree))
(defn sub-canopy-tree [tree] (o/sub-canopy-tree tree))
(defn bush [bush] (o/bush bush))
(defn herbaceous [plant] (o/herbaceous plant))
(defn root [plant] (o/root plant))
(defn path [plant] (o/path plant))
(defn vine [plant] (o/vine plant))
(defn area [plant] (o/area plant))
(defn structure [plant] (o/structure plant))
(defn patch [plant] (o/patch plant))
(defn ground [g]
  (o/ground g))

(defn marker [m] (o/marker m))
(defn point
  ([xy] (point 9999 xy "5"))
  ([eid xy] (point eid xy "5"))
  ([eid [x y] r]
   (o/point eid [x y] r)))

(defn compass [size rotation active] (o/compass size rotation active))

(defn zoom
  ([size grow-cb shrink-cb] (zoom :vertical size grow-cb shrink-cb))
  ([direction size grow-cb shrink-cb]
   (o/zoom direction size grow-cb shrink-cb)))

(defn ruler
  ([[x1 y1] [x2 y2]] (ruler [x1 y1] [x2 y2] :cm))
  ([[x1 y1] [x2 y2] units] (ruler [x1 y1] [x2 y2] units 5))
  ([[x1 y1] [x2 y2] units scale]
   (o/ruler [x1 y1] [x2 y2] units scale)))

#?(:clj
   (defn string->stream
     ([s] (string->stream s "UTF-8"))
     ([s encoding] (r/string->stream s encoding))))


